// extracted by mini-css-extract-plugin
module.exports = {"popover":"i_IV","buttons":"i_IW"};